// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"94ccb245","239":"130a82f5","453":"c1c127ce","732":"7f0c9a22"}[chunkId] + ".chunk.js";
};